import React, {Component} from 'react';

import Select from 'components/common/select/Select.component';
import { FormField } from 'components/common/FormField.component';
import _ from "lodash";

const COMMON_PARAMS = {
    prefix: '',
    page: 1,
    rows: 20,
    usedInIndexOnly: true,
    showInactive: true
};



export class AdvancedSearch extends Component {
    constructor(props) {
        super(props);
        this.state = {
            options: [],
            selectedAccount: '',
            currentPage: COMMON_PARAMS.page,
            records: 1,
            isLoading: false,
            currentInputValue: ''
        };
        this.requests = [];
        this.getOptions = this.getOptions.bind(this);
        this.filterOptions = this.filterOptions.bind(this);
        this.getOptionsWithDelay = _.debounce((event, func, dimension, value) => {
            this.filterOptions(func, dimension, value)
        }, 1000);
        this.cancelCalls = this.cancelCalls.bind(this);
        this.scroll = this.scroll.bind(this);
        this.callBackend = this.callBackend.bind(this);
        this.focus = this.focus.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.inputElement = React.createRef();
    }


    focus() {
        this.inputElement.focus();
    }

    handleInputChange(newValue, actionMeta) {
        this.setState({ currentInputValue: newValue });
        if (this.props.onInputChange) {
            this.getOptionsWithDelay(this, this.props.type, this.props.dimension, newValue);
        }
        return newValue;
    }

    filterOptions(func, dimension, value) {
        if (this.state.records > 20) {
            this.getOptions(func, dimension, value);
        }
    }

    componentWillUnmount() {
        this.cancelCalls();
        this.getOptionsWithDelay.cancel();
    }

    cancelCalls() {
        this.requests.forEach(p => {
            if (p)
                p.cancel();
        });
        this.requests = [];
    }

    callBackend(functionName, data, dimension) {
        functionName(data, dimension).then(response => {
            let values = response.rows;
            if (values && values.length > 0) {
                if (this.props.hasAny)
                    values.unshift({number: -99, name: this.props.translate("generic.genericAny"), active: true});
                if (this.props.hasUnassigned)
                    values.unshift({number: -1, name: this.props.translate("generic.unassigned"), active: true});
            }

            const results = values.map(item => {
                return {
                    label: (item.number > 0 || typeof item.number === 'string' ? (item.number + " - ") : "") + item.name,
                    value: item.number,
                    color: (item.active) ? 'black' : 'lightgrey'
                }
            });
            this.setState({
                options: results,
                isLoading: false,
                currentPage: response.page,
                records: response.records
            });
        })
    }

    getOptions(func, dimension, value) {
        this.setState({
            options: [],
            isLoading: true
        }, () => {
            if (typeof dimension === "undefined")
                return [];

            let data = Object.assign({}, COMMON_PARAMS);
            data.usedInIndexOnly = this.props.usedInIndexOnly === false ? false : COMMON_PARAMS.usedInIndexOnly;

            if (value) {
                data.prefix = value;
            }

            this.requests.push(this.callBackend(func, data, dimension));
        });
    }

    scroll(func, dimension, value) {
        if (this.state.records > this.state.options.length) {
            let data = Object.assign({}, COMMON_PARAMS);
            if (this.props.usedInIndexOnly === false)
                data.usedInIndexOnly = false;
            if (value)
                data.prefix = this.state.currentInputValue;
            data.page = this.state.currentPage + 1;

            let self = this;

            return func(data, dimension).then(response => {
                const results = response.rows.map(item => {
                    return {
                        label: "[" + item.number + "] " + item.name,
                        value: item.number,
                        color: (item.active) ? 'black' : 'lightgrey'
                    }
                });
                this.setState({
                    options: Object.assign([], self.state.options).concat(results),
                    currentPage: response.page,
                    records: response.records
                });
            });
        }
    }


    render() {
         return (
             <div aria-labelledby={"search" + this.props.name + "txt"} role="listitem">
                        <FormField
                            id={"search" + this.props.name}
                            label={this.props.name || ""}
                        >
                            <Select
                                isClearable={true}
                                ref={(element) => {
                                    this.inputElement = element;
                                }}
                                aria-labelledby={"search" + this.props.name + "txt"}
                                isDisabled={this.props.disabled}
                                isSearchable={true}
                                isLoading={this.state.isLoading}
                                onBlurResetsInput={false}
                                onCloseResetsInput={false}
                                value={this.props.selectedValue}
                                placeholder={this.props.placeholder}
                                showNoOptions={false}
                                menuPlacement={this.props.menuPlacement ? this.props.menuPlacement : "bottom"}
                                menuPosition={this.props.menuPosition ? this.props.menuPosition : "absolute"}
                                menuPortalTarget={this.props.menuPortalTarget ? this.props.menuPortalTarget :document.body}
                                tabIndex={this.props.tabIndex}
                                autoFocus={this.props.autoFocus}
                                options={this.state.options}
                                tabSelectsValue={this.props.tabSelectsValue ? this.props.tabSelectsValue : false}
                                onMenuOpen={this.getOptions.bind(this, this.props.type, this.props.dimension)}
                                onInputChange={this.handleInputChange}
                                onChange={this.props.onChange.bind(this)}
                                onMenuScrollToBottom={this.scroll.bind(this, this.props.type, this.props.dimension)}
                                closeMenuOnSelect={true}
                                translate={this.props.translate}
                            />
                        </FormField>
                    </div>

        );
    }
    }
